module.exports = __webpack_public_path__ + "img/faq-bg.5985b0d9.png";